import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import { Chip } from "@mui/material";
import PhotoLibraryRoundedIcon from "@mui/icons-material/PhotoLibraryRounded";
import FolderRoundedIcon from "@mui/icons-material/FolderRounded";
import AccountBalanceWalletRoundedIcon from "@mui/icons-material/AccountBalanceWalletRounded";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import DeleteOutlineRoundedIcon from "@mui/icons-material/DeleteOutlineRounded";
import { ActionIconButton } from "../../components/datatable/DataGridActions";

const columnsData = [
  {
    field: "sno",
    headerName: "SNO",
    minWidth: 72,
    width: 72,
    maxWidth: 80,
    sortable: false,
  },
  {
    field: "name",
    headerName: "Name",
    minWidth: 140,
    flex: 1,
    renderCell: (params) => {
      return (
        <div className="cellWithImg">
          {params.row?.avatar_url ? (
            <img
              className="cellImg"
              src={params.row?.avatar_url}
              alt="avatar"
            />
          ) : (
            <PersonOutlineIcon style={{ marginRight: 12, marginLeft: 4 }} />
          )}
          {params.row.name}
        </div>
      );
    },
  },
  {
    field: "enrollment_id",
    headerName: "Enrollment Id",
    minWidth: 120,
  },
  {
    field: "phone",
    headerName: "Phone",
    minWidth: 120,
  },
  {
    field: "basic_amount",
    headerName: "Basic Amount",
    minWidth: 110,
  },
  {
    field: "is_sponsored",
    headerName: "Sponsored",
    minWidth: 110,
    renderCell: (params) => {
      return (
        <div>
          <Chip
            label={params.row.is_sponsored ? "Yes" : "No"}
            variant="outlined"
            color={params.row.is_sponsored ? "success" : "warning"}
          />
        </div>
      );
    },
  },

  {
    field: "category_name",
    headerName: "Category",
    minWidth: 110,
  },
];

let actionHeader = (
  handleDelete,
  setOpen,
  setSelectedRow,
  setOpenExpences,
  setOpenPhotos,
  setOpenDocuments,
) => {
  const actionColumn = [
    {
      field: "action",
      headerName: "Action",
      minWidth: 220,
      maxWidth: 260,
      sortable: false,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        return (
          <div className="cellAction cellAction--icons">
            <ActionIconButton
              title="Photos"
              onClick={() => {
                setOpenPhotos(true);
                setSelectedRow(params.row);
              }}
            >
              <PhotoLibraryRoundedIcon fontSize="small" />
            </ActionIconButton>
            <ActionIconButton
              title="Documents"
              onClick={() => {
                setOpenDocuments(true);
                setSelectedRow(params.row);
              }}
            >
              <FolderRoundedIcon fontSize="small" />
            </ActionIconButton>
            <ActionIconButton
              title="Expenses"
              onClick={() => {
                setOpenExpences(true);
                setSelectedRow(params.row);
              }}
            >
              <AccountBalanceWalletRoundedIcon fontSize="small" />
            </ActionIconButton>
            <ActionIconButton
              title="Edit kid"
              onClick={() => {
                setOpen(true);
                setSelectedRow(params.row);
              }}
            >
              <EditRoundedIcon fontSize="small" />
            </ActionIconButton>
            <ActionIconButton
              title="Delete kid"
              onClick={() => handleDelete(params.row.id)}
              color="error"
            >
              <DeleteOutlineRoundedIcon fontSize="small" />
            </ActionIconButton>
          </div>
        );
      },
    },
  ];
  return actionColumn;
};

const columnHeader = {
  columnsData,
  actionHeader,
  flex: 1,
};

export default columnHeader;
